import type { SeparatorBlockProps } from "./types";
import PanelContainer from "../../lib/panel/panel-container";
import PanelTranslationState from "../../lib/panel/panel-translation-state";
import { BlockPanelProps } from "../../lib/register-block";
import EmailPanelVerticalSpacing from "./email-panel-vertical-spacing";
import EmailPanelInvisible from "./email-panel-invisible";


export function SeparatorEmailPanelRenderer(blockProps: BlockPanelProps<SeparatorBlockProps>) {
  return (
    <PanelContainer blockProps={blockProps}>
      <EmailPanelVerticalSpacing/>
      <EmailPanelInvisible/>
      <PanelTranslationState mode="not-translatable" portal />
    </PanelContainer>
  );
}
